import React, { memo } from "react";
import { Button, TextField } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Controller } from "react-hook-form";
import { BeatLoader } from "react-spinners";
import ReadMoreContent from "./ReadMoreContent";
import { useTranslation } from "react-i18next";
import LoginHelpButton from "components/LoginHelpButton";

function LoginForm({
  title,
  control,
  errors,
  onSubmit,
  otpLoading,
  otpSendError,
  merchantConfig,
  fieldContent,
  variant,
  labelColor,
  buttonRadius,
  helperTextResolver,
  brandHomePageNote,
  onOpenTerms,
  textFieldProps,
  buttonStyle,
  buttonSx,
  arrowTop,
  termsTextStyle,
  termsLinkStyle,
}) {
  const { t } = useTranslation();

  return (
    <>
      <p className="return-title">{title}</p>
      <form onSubmit={onSubmit} style={{ maxWidth: "450px", width: "100%" }}>
        <label htmlFor="customerIdentifier" style={{ display: "block" }}>
          <p className="input-label" style={labelColor ? { color: labelColor } : {}}>
            {fieldContent.label}
          </p>
          <Controller
            control={control}
            defaultValue=""
            rules={{
              required: true,
              pattern: fieldContent.pattern,
            }}
            name="customerIdentifier"
            render={({ field }) => (
              <TextField
                fullWidth
                id="customerIdentifier"
                variant={variant}
                error={Boolean(errors.customerIdentifier)}
                helperText={helperTextResolver(fieldContent)}
                placeholder={fieldContent.placeholder}
                {...textFieldProps}
                {...field}
              />
            )}
          />
        </label>
        {otpSendError && (
          <p
            style={{
              color: "rgba(221, 67, 93, 1)",
              fontSize: "12px",
            }}
          >
            {typeof otpSendError === "string"
              ? otpSendError
              : t("login.otpRetry")}
          </p>
        )}
        <Button
          type="submit"
          variant="contained"
          endIcon={
            otpLoading ? (
              null
            ) : (
              <ArrowForwardIcon
                sx={{ position: "relative", top: arrowTop }}
              />
            )
          }
          disabled={otpLoading}
          className="otp-action"
          color="primary"
          style={{
            width: "100%",
            borderRadius: buttonRadius,
            ...buttonStyle,
          }}
          sx={buttonSx}
        >
          {otpLoading ? (
            <span className="ui-label">
              <BeatLoader color={merchantConfig.secondary_theme_color} />
            </span>
          ) : (
            <span className="ui-label">
              {t("common.actions.proceed")}
            </span>
          )}
        </Button>
        {brandHomePageNote &&
          brandHomePageNote !== null &&
          brandHomePageNote !== "" && (
            <p className="brand-note">
              <ReadMoreContent
                content={brandHomePageNote}
                maxLength={490}
                themeColor={merchantConfig.primary_theme_color}
              />
            </p>
          )}
        <div style={termsTextStyle}>
          <span>{t("login.byProceeding")} </span>
          <button
            type="button"
            onClick={onOpenTerms}
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              font: "inherit",
              ...termsLinkStyle,
            }}
          >
            <span className="ui-label">{t("login.termsLink")}</span>
          </button>
        </div>
        <LoginHelpButton
          merchantConfig={merchantConfig}
          color={labelColor}
          borderRadius={buttonRadius}
        />
      </form>
    </>
  );
}

export default memo(LoginForm);
